import {
  AiToolCallState,
  TreadAgentApiWriteType,
  TreadAgentSingleRecordWriteType,
} from '@treadinc/horizon-api-spec';
import { reaction } from 'mobx';
import { useEffect } from 'react';

import useCompanySettings from '~hooks/useCompanySettings/useCompanySettings';
import useUsers from '~hooks/useUsers/useUsers';
import { useStores } from '~store';

export default function useRefreshAfterTreadAgentWrites() {
  const { treadAgentStore, userStore } = useStores();
  const { getUser } = useUsers();
  const { refreshCompanySettings } = useCompanySettings();

  useEffect(
    () =>
      reaction(
        () => treadAgentStore.lastResolvedToolCall,
        (toolCall) => {
          if (toolCall?.state !== AiToolCallState.APPLIED) {
            return;
          }

          const { preview, output } = toolCall;
          const userId = userStore.user.id;
          const companyId = userStore.userCompany.id;
          const isOwnUserWrite =
            (preview?.kind === TreadAgentSingleRecordWriteType.SINGLE_RECORD_WRITE &&
              preview.target.type === 'user' &&
              preview.target.id === userId) ||
            (Boolean(userId) && output?.id === userId);
          const isCompanySettingsWrite =
            preview?.kind === TreadAgentApiWriteType.API_WRITE &&
            preview.path === `/v1/companies/${companyId}/settings`;
          const writeTargetIsUnknown = !preview;

          if (isOwnUserWrite) {
            void getUser();
          } else if (isCompanySettingsWrite || writeTargetIsUnknown) {
            void refreshCompanySettings(companyId);
          }
        },
      ),
    [getUser, refreshCompanySettings, treadAgentStore, userStore],
  );
}
